import { defineMessages } from 'react-intl';

const messages = defineMessages({
  columnDropdownNoneSelected: {
    description: 'Assign To Dropdown option denoting there has not been a selection',
    defaultMessage: 'None',
    id: '5gXnKk',
  },
  columnDropdownNameNobody: {
    description: 'Assign To Dropdown option denoting nobody is assigned',
    defaultMessage: '(Nobody)',
    id: 'SKgWoV',
  },
});

export default messages;
